import React, { Fragment } from 'react'
import Table from 'UI/Table'
import ActionColumn from 'UI/Table/components/ActionColumn'
import EditableColumn from 'UI/Table/components/EditableColumn'
import Filters from 'Features/Filters'
import { filteredPhysicalAssets } from './Data'
import { includes, map, sortBy, filter } from 'lodash'
import assetOptions from './assetOptions'

class PhysicalAssetsTable extends React.Component {
  constructor(props) {
    super(props)

    this.state = {
      loading: false,
      filters: {
        location: 'All',
        manufacturer: 'All',
        type: 'All',
        model: 'All',
        cloudcore: 'All',
        status: [{ label: 'Live', value: 'Live' }]
      },
      fields: {
        id: null,
        asset_tag: null,
        status: null,
        model: null,
        name: null,
        location: null,
        type: null,
        serial_number: null,
        manufacturer: null,
        data_source: null,
        owner_id: null
      },
      physicalAssets: props.physical_assets,
    }
  }

  changeFilters = filters => this.setState({ filters })
  updateState = newState => this.setState(newState)

  editableNonCloudCoreColumn (row, type = 'text', options = [], fieldName) {
    const { fields } = this.state
    const { original, column } = row

    if (original.automaticReporting) {
      return row.value
    }

    return (<EditableColumn {...{ row, type: type, fields, fieldName: fieldName || column.id, updateState: this.updateState, options }} />)
  }

  modelOptions = ({ filters, models }) => {
    if (filters.manufacturer != 'All') {
      return filter(models, ({ manufacturer }) => includes(map(filters.manufacturer, 'value'), manufacturer)  )
    }

    return models
  }

  render () {
    const { filters, physicalAssets, loading, fields } = this.state
    const { locations, manufacturers, types, models, statusOptions, sites, manufacturerOptions, typeOptions, ownerOptions } = this.props
    const { updateState, changeFilters, modelOptions } = this
    const formStatusOptions = map(statusOptions, status => ({ value: status.value.toLowerCase(), label: status.label }))
    const nonCloudCoreOptions = [{ value: true, label: 'CloudCore' }, { value: false, label: 'Non-CloudCore' } ]
    const columns = [
      {
        Header: '',
        maxWidth: 80,
        style: { textAlign: 'center' },
        filterable: false,
        Cell: (row) => (
          <ActionColumn {...{ row, fields, updateState, url: '/assets/physical', options: physicalAssets, arrayName: 'physicalAssets' }} />
        ),
      },
      { Header: 'Asset Tag', accessor: 'asset_tag', Cell: row => <EditableColumn {...{ row, type: 'text', fields, updateState }} /> },
      { Header: 'Model/Type', accessor: 'model', width: 200, Cell: row => this.editableNonCloudCoreColumn(row) },
      { Header: 'Name', accessor: 'name', width: 200, Cell: row => this.editableNonCloudCoreColumn(row) },
      { Header: 'Location', accessor: 'location', Cell: row => this.editableNonCloudCoreColumn(row, 'select', sites) },
      { Header: 'Asset Type', accessor: 'type', Cell: row => this.editableNonCloudCoreColumn(row, 'select', typeOptions) },
      {
        Header: 'Status',
        accessor: 'status',
        width: 230,
        Cell: row => <EditableColumn {...{ row, type: 'select', fields, updateState, options: assetOptions(row.original) }} />
      },
      { Header: 'Serial No', accessor: 'serial_number', Cell: row => <EditableColumn {...{ row, type: 'text', fields, updateState }} /> },
      { Header: 'Manufacturer', accessor: 'manufacturer', Cell: row => this.editableNonCloudCoreColumn(row, 'select', manufacturerOptions) },
      { Header: 'Owner', accessor: 'owner', id: 'owner_id', Cell: row => <EditableColumn {...{ row, type: 'select', fields, updateState, options: ownerOptions }} /> },
      { Header: 'Data Source', accessor: 'data_source' },
      { Header: 'Purchased Date', accessor: 'purchased_date', Cell: row => <EditableColumn {...{ row, type: 'date', fields, updateState }} /> },
      { Header: 'Rack Number', accessor: 'rack_number', Cell: row => <EditableColumn {...{ row, type: 'text', fields, updateState }} /> },
      { Header: 'Number of U', accessor: 'number_of_u', Cell: row => <EditableColumn {...{ row, type: 'text', fields, updateState }} /> },
      { Header: 'Starting U number', accessor: 'starting_u_number', Cell: row => <EditableColumn {...{ row, type: 'text', fields, updateState }} /> },
      { Header: 'Warranty Status', accessor: 'warranty_status', Cell: row => <EditableColumn {...{ row, type: 'text', fields, updateState }} /> }
    ]

    return (
      <Fragment>
        <Filters filters={filters} onChange={changeFilters} className='mt-3'>
          <Filters.Select filterName='status' label='Status' options={statusOptions} />
          <Filters.Select filterName='location' label='Location' options={[...locations, ...sites]} />
          <Filters.Select filterName='manufacturer' label='Manufacturer' options={sortBy(manufacturers, 'label')} />
          <Filters.Select filterName='type' label='Type' options={sortBy(types, 'label')} />
          <Filters.Select filterName='model' label='Model' options={sortBy(modelOptions({ filters, models }), 'label')} />
          <Filters.Select filterName='cloudcore' label='Asset usage' options={sortBy(nonCloudCoreOptions, 'label')} />
        </Filters>

        <Table {...{ data: filteredPhysicalAssets(filters, physicalAssets), columns, loading }} filterable />
      </Fragment>
    )
  }
}

export default PhysicalAssetsTable
